export default __webpack_public_path__ + "static/media/person-outline-1-white.56986784.svg";